import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  name: string;
  fullName?: string | null;
  phone?: string | null;
  address?: string | null;
  bannerUrl?: string | null;
  avatarUrl?: string | null;
  isClientUser?: boolean;
}

interface AuthState {
  user: User | null;
  accessToken: string | null;
  refreshToken: string | null;
  csrfToken: string | null;
  setAuth: (
    user: User,
    accessToken?: string | null,
    refreshToken?: string | null,
    csrfToken?: string | null,
  ) => void;
  setSession: (
    accessToken?: string | null,
    refreshToken?: string | null,
    csrfToken?: string | null,
  ) => void;
  setCsrfToken: (csrfToken: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      csrfToken: null,
      setAuth: (user, accessToken, refreshToken, csrfToken) => {
        set((state) => ({
          user,
          accessToken: accessToken || state.accessToken,
          refreshToken: refreshToken || state.refreshToken,
          csrfToken: csrfToken || state.csrfToken,
        }));
      },
      setSession: (accessToken, refreshToken, csrfToken) => {
        set((state) => ({
          accessToken: accessToken || state.accessToken,
          refreshToken: refreshToken || state.refreshToken,
          csrfToken: csrfToken || state.csrfToken,
        }));
      },
      setCsrfToken: (csrfToken) => {
        set({ csrfToken });
      },
      logout: () => {
        localStorage.removeItem('workspaceId');
        set({ user: null, accessToken: null, refreshToken: null, csrfToken: null });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
      }),
      merge: (persistedState: any, currentState) => ({
        ...currentState,
        ...(persistedState || {}),
      }),
    }
  )
);
